import React from "react";
import QrReader from "react-qr-reader";
import { connect } from "react-redux";
import useSound from "use-sound";
import boopSfx from "../assets/sounds/beep-01a.mp3";
import { addProduct } from "../cart/services/cart/actions";

const ScanBarCode = (props) => {
	const [play] = useSound(boopSfx);
	const [state, setState] = React.useState({
		result: "No result",
	});

	const handleScan = (data) => {
		if (data) {
			new Promise((resolve, reject) => {
				setTimeout(() => {
					play();
					setState({
						result: data,
					});
					console.log("scan data=", JSON.parse(data));
					console.log("props.products=", props.products);
					let inputs = JSON.parse(data);
					let productToadd = props.products.find(
						(x) => (
							x.categoryId === inputs.categoryId &&
								x.companyId === inputs.companyId &&
								x.siteId === inputs.id,
							x.stockId === inputs.stockId &&
								x.sku ===
									inputs.categoryId +
										"#" +
										inputs.subCategoryId +
										"#" +
										inputs.productId
						)
					);

					console.log("props.products.find=", productToadd);
					try {
						props.addProduct(productToadd);
					} catch (e) {}

					resolve();
				}, 1000);
			});
		}
	};
	const handleError = (err) => {
		console.error(err);
	};

	return (
		<div style={{ width: 200, heigth: 200 }}>
			<QrReader
				delay={300}
				onError={handleError}
				onScan={handleScan}
				style={{ width: "100%", heigth: "100%" }}
			/>
			<p>{state.result}</p>
		</div>
	);
};
const mapStateToProps = (state) => {
	console.log("cart state=", state);
	return {
		products: state.shelf.products,
	};
};

export default connect(mapStateToProps, { addProduct })(ScanBarCode);
